import * as React from 'react';

import PropTypes from 'prop-types';

import PageFooter from 'bundles/page-footer/components/PageFooter';
import PageHeader from 'bundles/page-header/components/PageHeader';
import IsMobileScreenContext from 'bundles/page/contexts/IsMobileScreenContext';
import LearnerProvider from 'bundles/search-common/providers/LearnerProvider';
import useMarketingScripts from 'bundles/seo/components/hooks/useMarketingScripts';
import useMobileScreen from 'bundles/unified-seo-content-common/utils/useMobileScreen';

import 'css!bundles/unified-seo-content-common/styl/index';

type Store = $TSFixMe;

type Context = {
  getStore: (name: string) => Store;
};

type Props = {
  children?: JSX.Element;
};

const SEOContentPageWrapper = ({ children }: Props, { getStore }: Context) => {
  const isMobileScreenInfo = useMobileScreen(getStore('ApplicationStore').getUserAgent());
  useMarketingScripts();

  return (
    <IsMobileScreenContext.Provider value={isMobileScreenInfo}>
      <div style={{ minHeight: '100vh', backgroundColor: 'var(--cds-color-neutral-background-primary)' }}>
        <PageHeader showLanguagesDropdown />
        <LearnerProvider>
          <div>{children}</div>
        </LearnerProvider>
        <PageFooter />
      </div>
    </IsMobileScreenContext.Provider>
  );
};

SEOContentPageWrapper.contextTypes = {
  getStore: PropTypes.func.isRequired,
};

/**
 * SEOContentPageWrapper component.
 * It serves as an SEO content page wrapper to provide some context and page layout.
 *
 * @param {React.ReactNode} props.children - The child components to be rendered within the wrapper.
 * @returns {JSX.Element} The rendered SEOContentPageWrapper component.
 *
 * @contextTypes
 * @property {Function} getStore - Required function for accessing application stores */
export default SEOContentPageWrapper;
